import type { FormItem } from 'form/types';

const step: FormItem[] = [
  {
    type: 'input',
    id: 'roleTitle',
    label: 'Your role',
    placeholder: 'e.g Site operator, Duty holder'
  },
  {
    type: 'spacer',
    id: 'sp-1',
    label: ''
  },
  {
    type: 'checkbox',
    id: 'confirm',
    label: 'I will ensure compliance'
  }
];

export default step;
